import { BrowserRouter, Route, Routes } from "react-router-dom";

import AppRoutes from "./containers/routes";
import { AppContextProvider } from "./context/AppContext";
import Login from "./containers/Login";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="*"
            element={
              <AppContextProvider>
                <AppRoutes />
              </AppContextProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
